import React from "react";
import { Busy } from "../presentational/busy";
import { Card } from "../presentational/card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons/faArrowCircleLeft";
import ReactGA from "react-ga";
import styles from "../../styles/panels/campaignInstructions.css";
import * as utilities from "../../middleware/utilities";

export class CampaignInstructions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidList: [],
    };
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/CampaignInstructions");
    utilities
      .isCodeValid(this.props.code)
      .then((valid) => {
        if (!valid) {
          this.props.onCodeError();
        }
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }
  renderNavigation() {
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          <div
            className={styles.icon}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Back Button",
                label: "/Spend/CampaignInstructions",
              });
              this.props.onBack();
            }}
          >
            <FontAwesomeIcon icon={faArrowCircleLeft} />
          </div>
          {this.props.dictionary.campaign_instructions_header}
        </div>
      </div>
    );
  }

  renderContactInputs() {
    let nameValid = this.state.invalidList.indexOf("Name") > -1 ? false : true;
    let phoneValid =
      this.state.invalidList.indexOf("Phone") > -1 ? false : true;
    let emailValid =
      this.state.invalidList.indexOf("Email") > -1 ? false : true;
    return (
      <div>
        <div className={styles.group}>
          <label
            className={styles.label + (nameValid ? "" : " " + styles.error)}
          >
            {this.props.dictionary.campaign_instructions_name} (Required)
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.nameInput +
              (nameValid ? "" : " " + styles.error)
            }
            type="text"
            value={this.props.instructions.name}
            onChange={(event) => {
              this.props.onInstructionsChanged({
                ...this.props.instructions,
                name: event.target.value,
              });
            }}
          />
          {nameValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.campaign_instructions_name}
            </div>
          )}
        </div>
        <div className={styles.group}>
          <label
            className={styles.label + (phoneValid ? "" : " " + styles.error)}
          >
            {this.props.dictionary.campaign_instructions_phone} (Required)
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.phoneInput +
              (phoneValid ? "" : " " + styles.error)
            }
            type="text"
            value={this.props.instructions.phone}
            onChange={(event) => {
              this.props.onInstructionsChanged({
                ...this.props.instructions,
                phone: event.target.value,
              });
            }}
          />
          {phoneValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.campaign_instructions_phone}
            </div>
          )}
        </div>
        <div className={styles.group}>
          <label
            className={styles.label + (emailValid ? "" : " " + styles.error)}
          >
            {this.props.dictionary.campaign_instructions_email} (Required)
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.emailInput +
              (emailValid ? "" : " " + styles.error)
            }
            type="text"
            value={this.props.instructions.email}
            onChange={(event) => {
              this.props.onInstructionsChanged({
                ...this.props.instructions,
                email: event.target.value,
              });
            }}
          />
          {emailValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.campaign_instructions_email}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderAddressInputs() {
    let addressValid =
      this.state.invalidList.indexOf("Address") > -1 ? false : true;
    let address2Valid = true;
    let cityValid = this.state.invalidList.indexOf("City") > -1 ? false : true;
    let stateValid =
      this.state.invalidList.indexOf("State") > -1 ? false : true;
    let zipValid = this.state.invalidList.indexOf("Zip") > -1 ? false : true;
    return (
      <div>
        <div className={styles.group}>
          <label
            className={styles.label + (addressValid ? "" : " " + styles.error)}
          >
            {this.props.dictionary.campaign_instructions_address} (Required)
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.addressInput +
              (addressValid ? "" : " " + styles.error)
            }
            type="text"
            value={this.props.instructions.address}
            onChange={(event) => {
              this.props.onInstructionsChanged({
                ...this.props.instructions,
                address: event.target.value,
              });
            }}
          />
          {addressValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.campaign_instructions_address}
            </div>
          )}
        </div>
        <div className={styles.group}>
          <label
            className={styles.label + (address2Valid ? "" : " " + styles.error)}
          >
            {this.props.dictionary.campaign_instructions_address2}
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.addressInput +
              (address2Valid ? "" : " " + styles.error)
            }
            type="text"
            value={this.props.instructions.address2}
            onChange={(event) => {
              this.props.onInstructionsChanged({
                ...this.props.instructions,
                address2: event.target.value,
              });
            }}
          />
          {address2Valid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.campaign_instructions_address2}
            </div>
          )}
        </div>
        <div className={styles.group}>
          <div className={styles.city}>
            <label
              className={styles.label + (cityValid ? "" : " " + styles.error)}
            >
              {this.props.dictionary.campaign_instructions_city} (Required)
            </label>
            <input
              className={
                styles.input +
                " " +
                styles.cityInput +
                (cityValid ? "" : " " + styles.error)
              }
              type="text"
              value={this.props.instructions.city}
              onChange={(event) => {
                this.props.onInstructionsChanged({
                  ...this.props.instructions,
                  city: event.target.value,
                });
              }}
            />
            {cityValid ? null : (
              <div className={styles.errorMessage}>
                {this.props.validation.campaign_instructions_city}
              </div>
            )}
          </div>
          <div className={styles.state}>
            <label
              className={styles.label + (stateValid ? "" : " " + styles.error)}
            >
              {this.props.dictionary.campaign_instructions_state} (Required)
            </label>
            <input
              className={
                styles.input +
                " " +
                styles.stateInput +
                (stateValid ? "" : " " + styles.error)
              }
              type="text"
              value={this.props.instructions.state}
              onChange={(event) => {
                this.props.onInstructionsChanged({
                  ...this.props.instructions,
                  state: event.target.value,
                });
              }}
            />
            {stateValid ? null : (
              <div className={styles.errorMessage}>
                {this.props.validation.campaign_instructions_state}
              </div>
            )}
          </div>
          <div className={styles.zip}>
            <label
              className={styles.label + (zipValid ? "" : " " + styles.error)}
            >
              {this.props.dictionary.campaign_instructions_zip} (Required)
            </label>
            <input
              className={
                styles.input +
                " " +
                styles.zipInput +
                (zipValid ? "" : " " + styles.error)
              }
              type="text"
              value={this.props.instructions.zip}
              onChange={(event) => {
                this.props.onInstructionsChanged({
                  ...this.props.instructions,
                  zip: event.target.value,
                });
              }}
            />
            {zipValid ? null : (
              <div className={styles.errorMessage}>
                {this.props.validation.campaign_instructions_zip}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderNotesInputs() {
    let notesValid = true;
    return (
      <div className={styles.group}>
        <label
          className={styles.label + (notesValid ? "" : " " + styles.error)}
        >
          {this.props.dictionary.campaign_instructions_notes}
        </label>
        <textarea
          className={
            styles.input +
            " " +
            styles.notesInput +
            (notesValid ? "" : " " + styles.error)
          }
          value={this.props.instructions.notes}
          onChange={(event) => {
            this.props.onInstructionsChanged({
              ...this.props.instructions,
              notes: event.target.value,
            });
          }}
        />
        {notesValid ? null : (
          <div className={styles.errorMessage}>
            {this.props.validation.campaign_instructions_notes}
          </div>
        )}
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <div className={styles.commands}>
          <button
            className={styles.button + " " + styles.primary}
            onClick={() => {
              let invalidList = [];
              switch (this.props.instructions.distributionType) {
                case "Paper Check":
                  if (!this.props.instructions.address) {
                    invalidList.push("Address");
                  }
                  if (!this.props.instructions.city) {
                    invalidList.push("City");
                  }
                  if (!this.props.instructions.state) {
                    invalidList.push("State");
                  }
                  if (!this.props.instructions.zip) {
                    invalidList.push("Zip");
                  }
                  break;
                case "Particular Program":
                  break;
                case "Particular Person":
                  break;
                case "Other":
                  break;
              }
              if (!this.props.instructions.name) {
                invalidList.push("Name");
              }
              if (!this.props.instructions.phone) {
                invalidList.push("Phone");
              }
              let emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (
                !this.props.instructions.email ||
                !emailValidation.test(this.props.instructions.email)
              ) {
                invalidList.push("Email");
              }
              if (invalidList.length == 0) {
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Continue Button",
                  label: "/Spend/CampaignInstructions",
                });
                this.props.onContinue();
              } else {
                this.setState({ invalidList: invalidList });
              }
            }}
          >
            {this.props.dictionary.campaign_instructions_continue}
          </button>
        </div>
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
      </div>
    );
  }
  render() {
    if (!this.props.code || this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          {this.renderNavigation()}
          <div className={styles.content}>
            <div className={styles.information}>
              {this.props.dictionary.campaign_instructions_message}
            </div>
            <div className={styles.inputs}>
              <div className={styles.group}>
                <ul>
                  <li>
                    <input
                      type="radio"
                      name="distributionType"
                      value="No Instructions"
                      checked={
                        this.props.instructions.distributionType ===
                        "No Instructions"
                      }
                      onChange={(event) => {
                        this.props.onInstructionsChanged({
                          ...this.props.instructions,
                          distributionType: event.target.value,
                        });
                      }}
                    />
                    <label>
                      {
                        this.props.dictionary
                          .campaign_instructions_no_instructions
                      }
                    </label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="distributionType"
                      value="Paper Check"
                      checked={
                        this.props.instructions.distributionType ===
                        "Paper Check"
                      }
                      onChange={(event) => {
                        this.props.onInstructionsChanged({
                          ...this.props.instructions,
                          distributionType: event.target.value,
                        });
                      }}
                    />
                    <label>
                      {this.props.dictionary.campaign_instructions_paper_check}
                    </label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="distributionType"
                      value="Particular Program"
                      checked={
                        this.props.instructions.distributionType ===
                        "Particular Program"
                      }
                      onChange={(event) => {
                        this.props.onInstructionsChanged({
                          ...this.props.instructions,
                          distributionType: event.target.value,
                        });
                      }}
                    />
                    <label>
                      {
                        this.props.dictionary
                          .campaign_instructions_particular_program
                      }
                    </label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="distributionType"
                      value="Particular Person"
                      checked={
                        this.props.instructions.distributionType ===
                        "Particular Person"
                      }
                      onChange={(event) => {
                        this.props.onInstructionsChanged({
                          ...this.props.instructions,
                          distributionType: event.target.value,
                        });
                      }}
                    />
                    <label>
                      {
                        this.props.dictionary
                          .campaign_instructions_particular_person
                      }
                    </label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="distributionType"
                      value="Other"
                      checked={
                        this.props.instructions.distributionType === "Other"
                      }
                      onChange={(event) => {
                        this.props.onInstructionsChanged({
                          ...this.props.instructions,
                          distributionType: event.target.value,
                        });
                      }}
                    />
                    <label>
                      {this.props.dictionary.campaign_instructions_other}
                    </label>
                  </li>
                </ul>
              </div>

              {this.props.instructions.distributionType != "No Instructions" ? (
                <div>
                  {this.renderContactInputs()}
                  {this.props.instructions.distributionType == "Paper Check"
                    ? this.renderAddressInputs()
                    : null}
                  {this.renderNotesInputs()}
                </div>
              ) : null}
            </div>
          </div>
          {this.renderAside()}
        </div>
      );
    }
  }
}
